import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-notifications-partial',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule],
  templateUrl: './notifications-partial.component.html',
  styleUrls: ['./notifications-partial.component.scss'],
})
export class NotificationsPartialComponent implements OnInit {
  notifications: any[] = [];
  public user: any = null;
  showNotificationsBar: boolean = true;
  removeAll: string[] = [];
  notificationArrayPush: any[] = [];

  @Input() visibilityNotifications: boolean = false;
  @Output() notificationsPartial = new EventEmitter<boolean>();

  constructor(private _api: ApiService) {
    console.log('NotificationsPartialComponent constructor');
  }

  async ngOnInit(): Promise<void> {
    console.log('NotificationsPartialComponent ngOnInit');
    const localArray = localStorage.getItem('notificationArrayPush');
    if (localArray !== null) {
      this.notifications = JSON.parse(localArray);
      this.notificationArrayPush = this.notifications;
      console.log('estoy aqui array', localArray);
    }
  }

  ngOnDestroy(): void {
    console.log('NotificationsPartialComponent ngOnDestroy');
  }

  removeAlert(): void {
    this.notifications = [];
    this.notificationArrayPush = [];
    localStorage.removeItem('notificationArrayPush');
  }

  toggleNotificationsBar() {
    this.showNotificationsBar = !this.showNotificationsBar;
    console.log('togle', this.toggleNotificationsBar);
  }

  toggleShowTransicion(): void {
    let status = !this.visibilityNotifications;
    this.notificationsPartial.emit(status);
  }
  seeNotification(index: number) {
    this.notificationArrayPush[index].active = false;
    console.log('clickNotificaciones', index);
    localStorage.setItem(
      'notificationArrayPush',
      JSON.stringify(this.notificationArrayPush)
    );
  }

  /*
  toggleShowTransicion(){
    let targetContainer = '.noty-panel';
		let targetClass = 'active';
		var targetExpand = false;
		if ($(targetContainer).hasClass(targetClass)) {
			$(targetContainer).removeClass(targetClass);
		} else {
			$(targetContainer).addClass(targetClass);
			targetExpand = true;
		}
  }
 */
}
